<template>
  <el-dialog :visible.sync="visible" :title="plustitle" width="620px" :close-on-click-modal="false" @close="onClose">
    <div :class="`${isShow ? 'show-form ' : ''}m-form`">
      <el-form class="ghost-button-styles" label-width="140px">
        <el-form-item label="账号类型">
          <span v-if="isShow">{{ convertAccountType(landData.accountType) }}</span>
          <el-radio-group v-else v-model="landData.accountType">
            <el-radio-button :label="0" ghost>普通账号</el-radio-button>
            <el-radio-button :label="1" ghost>管家账号</el-radio-button>
            <el-radio-button :label="2" ghost>智投账号</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账号ID" v-if="type !== 0">
          <span>{{ landData.id }}</span>
        </el-form-item>
        <el-form-item label="媒体" style="height: 32px">
          <span v-if="isShow">{{ landData.mediaName }}</span>
          <el-select
            v-else
            :disabled="type === 1"
            v-model="landData.mediaId"
            placeholder="选择媒体"
            collapse-tags
            filterable
            clearable
            style="width: 99%; overflow: hidden"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in MEDIAS_DATA" :key="item.id" :value="item.id" :label="item.name" style="width: 99%"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号名称">
          <el-button type="text" v-if="isShow" v-clipboard:success="onCopy" v-clipboard:copy="landData.adAccount">
            {{ landData.adAccount }}
          </el-button>
          <el-input v-else v-model.trim="landData.adAccount" placeholder="请输入账号名称" style="width: 99%" />
        </el-form-item>
        <el-form-item label="账号简称">
          <el-button type="text" v-if="isShow" v-clipboard:success="onCopy" v-clipboard:copy="landData.adAccountSimpleName">
            {{ landData.adAccountSimpleName }}
          </el-button>
          <el-input v-else v-model.trim="landData.adAccountSimpleName" placeholder="请输入账号简称" style="width: 99%" />
        </el-form-item>
        <el-form-item label="密码">
          <el-button type="text" v-if="isShow" v-clipboard:success="onCopy" v-clipboard:copy="landData.adPwd">
            {{ nullToLine(landData.adPwd) }}
          </el-button>
          <el-input v-else v-model.trim="landData.adPwd" placeholder="请输入账号密码" style="width: 99%" />
        </el-form-item>
        <el-form-item label="计划主ID">
          <span v-if="isShow">{{ nullToLine(landData.advertiserId) }}</span>
          <el-input v-else v-model.trim="landData.advertiserId" placeholder="请输入计划主ID" style="width: 99%" />
        </el-form-item>
        <el-form-item label="投放返点">
          <span v-if="isShow">{{ nullToLine(landData.rebate) }}</span>
          <el-input-number
            v-else
            :max="3"
            :min="0.5"
            :controls="false"
            v-model.trim="landData.rebate"
            placeholder="请输入投放返点"
            style="width: 99%"
            @blur="inputPrecisionLimit('rebate', landData.rebate, landData, 6)"
          />
        </el-form-item>
        <el-form-item label="财务返点">
          <span v-if="isShow">{{ nullToLine(landData.finaRebate) }}</span>
          <el-input-number
            v-else
            :max="3"
            :min="0.5"
            :controls="false"
            v-model.trim="landData.finaRebate"
            placeholder="请输入财务返点"
            style="width: 99%"
            @blur="inputPrecisionLimit('finaRebate', landData.finaRebate, landData, 6)"
          />
        </el-form-item>
        <el-form-item label="代理商">
          <span v-if="isShow">{{ nullToLine(landData.agentName) }}</span>
          <el-select
            v-else
            v-model="landData.agentId"
            placeholder="选择代理商"
            filterable
            clearable
            style="width: 99%; overflow: hidden"
            @change="agentChange"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in dataSource.agentData"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              style="width: 99%"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票单位">
          <span v-if="isShow">{{ nullToLine(landData.invoiceUnit) }}</span>
          <el-input v-else v-model.trim="landData.invoiceUnit" placeholder="请输入开票单位" style="width: 99%" />
        </el-form-item>
        <el-form-item label="开户主体">
          <span v-if="isShow">{{ nullToLine(landData.companyName) }}</span>
          <el-row v-else>
            <el-col :span="15">
              <el-select
                v-model="landData.companyId"
                placeholder="选择开户主体"
                filterable
                clearable
                style="width: 99%; overflow: hidden"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in dataSource.companyData"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                  style="width: 99%"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="1">
              <el-button type="text" @click="$emit('on-company')">主体管理</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="结算方式">
          <span v-if="isShow">{{ convertSettle(landData.settleType) }}</span>
          <el-select v-else v-model="landData.settleType" :popper-append-to-body="false" style="width: 99%">
            <el-option :value="1" label="按消耗结算" />
            <el-option :value="2" label="按余额结算" />
          </el-select>
        </el-form-item>
        <el-form-item label="管理人员">
          <span v-if="isShow">{{ nullToLine(landData.optNames) }}</span>
          <el-select
            v-else
            v-model="landData.opIds"
            placeholder="选择管理人员"
            multiple
            collapse-tags
            filterable
            clearable
            style="width: 99%; overflow: hidden"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in OP_DATA" :key="item.id" :value="item.id" :label="item.name" style="width: 99%"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-switch v-model="landData.status" :active-value="1" :inactive-value="0" :disabled="isShow" />
        </el-form-item>
        <el-form-item label="授权应用" v-if="!needSecret || needAuthApp">
          <span v-if="isShow">{{ nullToLine(landData.authApp) }}</span>
          <el-select
            v-else
            v-model="landData.authAppId"
            placeholder="选择授权应用"
            filterable
            clearable
            style="width: 99%; overflow: hidden"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in authAppDataByMedia" :key="item.id" :value="item.id" :label="item.name" style="width: 99%"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理账号" v-if="!needAppIdAndSignKey">
          <span v-if="isShow">{{ nullToLine(landData.manageAccount) }}</span>
          <el-select
            v-else
            v-model="landData.manageAccountId"
            placeholder="选择管理账号"
            filterable
            clearable
            style="width: 99%; overflow: hidden"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in accountData" :key="item.id" :value="item.id" :label="item.name" style="width: 99%"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="APPID" v-if="needAppIdAndSignKey">
          <span v-if="isShow">{{ nullToLine(landData.appId) }}</span>
          <el-input v-else v-model.trim="landData.appId" placeholder="请输入APPID" style="width: 99%" />
        </el-form-item>
        <el-form-item label="加密秘钥" v-if="needSecret">
          <span v-if="isShow">{{ nullToLine(landData.secret) }}</span>
          <el-input v-else v-model.trim="landData.secret" placeholder="请输入加密秘钥" style="width: 99%" />
        </el-form-item>
        <el-form-item label="签名秘钥" v-if="needAppIdAndSignKey">
          <span v-if="isShow">{{ nullToLine(landData.signKey) }}</span>
          <el-input v-else v-model.trim="landData.signKey" placeholder="请输入签名秘钥" style="width: 99%" />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="m-foot">
        <el-button v-if="!isShow" @click="$emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import Cookies from 'js-cookie'
import { deepCopy, isEmpty, trim } from '@/common/js/utils'
import { Message } from 'element-ui'
import { initPageData, MEDIAS, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MEDIAS, SYS_USERS])
// eslint-disable-next-line
const props = defineProps({
  value: Boolean,
  loading: { type: Boolean, default: false },
  info: { type: Object, default: () => ({}) },
  type: { type: Number, default: 2 },
  dataSource: { type: Object, default: () => ({}) }
})

const OP_DATA = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const MEDIAS_DATA = computed(PAGE_REQUIRED_OPTS.MEDIAS)
// eslint-disable-next-line
const emit = defineEmits(['input', 'on-ok', 'on-refresh-data', 'on-company'])

const defaultLandData = {
  id: '',
  accountType: 0,
  mediaId: '',
  mediaName: '',
  adAccount: '',
  adAccountSimpleName: '',
  adPwd: '',
  advertiserId: '',
  rebate: 1,
  finaRebate: 1,
  agentName: '',
  invoiceUnit: '',
  companyName: '',
  settleType: 1,
  optNames: '',
  status: 1,
  authApp: '',
  opIds: [],
  manageAccount: '',
  manageAccountId: '',
  authAppId: '',
  appId: '',
  secret: '',
  signKey: ''
}

const landData = ref(deepCopy(defaultLandData))

// Computed
const visible = computed({
  get: () => props.value,
  set: (val) => emit('input', val)
})

const plustitle = computed(() => {
  const titleConfig = ['新增账号', '修改账号', '账号信息']
  return titleConfig[props.type]
})

const isShow = computed(() => props.type === 2)

const needAppIdAndSignKey = computed(() => {
  return ![10, 16, 32, 45, 157].includes(landData.value.mediaId)
})

const needSecret = computed(() => {
  return ![10, 16, 32, 45, 157].includes(landData.value.mediaId)
})

const needAuthApp = computed(() => {
  return [214].includes(landData.value.mediaId)
})

const authAppDataByMedia = computed(() => {
  return landData.value.mediaId > 0 ? (props.dataSource.authAppData || []).filter((ret) => ret.mediaId === landData.value.mediaId) : []
})

const accountData = computed(() => {
  return (props.dataSource.accountData || []).filter((acc) => acc.mediaId === landData.value.mediaId)
})

// Methods/Helpers
const nullToLine = (val) => val || '————'

const convertAccountType = (originVal) => {
  switch (originVal) {
    case 0:
      return '普通账号'
    case 1:
      return '管家账号'
    default:
      return ''
  }
}

const convertSettle = (originVal) => {
  switch (originVal) {
    case 1:
      return '按消耗结算'
    case 2:
      return '按余额结算'
    default:
      return ''
  }
}

const updateInfo = () => {
  const info = JSON.parse(JSON.stringify(props.info))
  landData.value = info && Object.keys(info).length !== 0 ? info : deepCopy(defaultLandData)
  // 新建账号时管理人员默认选中当前登陆人员
  if (props.type === 0) {
    landData.value.opIds = [Number(Cookies.get('ch_op_id'))]
  }
}

const onClose = () => {
  // Original logic: bindGetData checks if !e (closing) -> updateInfo
  nextTick(() => {
    updateInfo()
  })
}

const submit = () => {
  const params = deepCopy(landData.value)
  if (!isShow.value) {
    const { mediaId, adAccount, advertiserId, agentId } = params
    if (!mediaId || mediaId <= 0) {
      Message.warning('请选择媒体！')
      return
    }
    if (!adAccount) {
      Message.warning('请输入账号名称！')
      return
    }
    if (!advertiserId) {
      Message.warning('请输入计划主ID！')
      return
    }
    if (!agentId || agentId <= 0) {
      Message.warning('请选择代理商！')
      return
    }
  }
  emit('on-ok', deepCopy(landData.value))
}

const agentChange = (agentId) => {
  const agent = (props.dataSource.agentData || []).find((ret) => ret.id === agentId)
  if (agent) {
    const agentName = agent.name
    const index = agentName.indexOf('-')
    if (index > -1) {
      landData.value.invoiceUnit = agentName.substring(index + 1)
    }
  }
}

const inputPrecisionLimit = (key, val, obj, precision) => {
  if (isEmpty(val)) return val
  val = trim(val)
  if (precision > 0) val = parseFloat(val).toFixed(precision)
  else val = parseInt(val)
  obj[key] = isEmpty(val) ? 0 : val
}

const onCopy = () => {
  Message.success('复制成功！')
}

// Watchers
watch(
  () => props.info,
  () => {
    nextTick(() => {
      updateInfo()
    })
  },
  { deep: true }
)

watch(
  () => props.value,
  (nVal, oVal) => {
    if (oVal && !nVal) {
      emit('on-refresh-data')
    }
  }
)

watch(needAppIdAndSignKey, (nVal) => {
  if (nVal) {
    landData.value.manageAccountId = ''
    landData.value.authAppId = ''
  } else {
    landData.value.appId = undefined
    landData.value.signKey = undefined
  }
})

watch(needSecret, (nVal) => {
  if (nVal) {
    landData.value.authAppId = ''
  } else {
    landData.value.secret = undefined
  }
})

// Lifecycle
onMounted(() => {
  nextTick(() => {
    updateInfo()
  })
})
</script>

<style lang="scss" scoped>
.c-account-info {
  position: relative;
}

.m-form {
  overflow: auto;
  max-height: 480px;
}
::v-deep .el-input__inner {
  text-align: left;
}
</style>
